import {useNavigate, useParams} from 'react-router-dom'
import {HeaderTitle} from '../../../../../common/HeaderTitle.jsx'
import ButtonWithIcon from '../../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../../common/Icons.jsx'
import Wizard from '../../../../../common/wizard/Wizard.jsx'
import {
    Podsumowanie,
    Start,
    EtapInicjacji,
    EtapPrzygotowania,
    EtapRealizacji,
    EtapZamykania
} from '../../../lib/components/planHarmForm/ph1/pages/index.js'
import {useSelector} from 'react-redux'
import {useZlozHarm} from "../../../../../../api/domain/planHarm/mutations/useZlozHarm.jsx";
import {useQueryClient} from "@tanstack/react-query";
import {CLEAR_PH} from "../../../lib/components/planHarmForm/ph1/clearing/clear_ph.js";
const ViewPlanHarmForm = () => {

    const WZOR_NAME = 'ph1'
    const {rejestrId, tryb} = useParams()
    const rola = useSelector((state) => state.user.role)
    const rolaParam = rola === 'oper' ? 'oper/' : '/'
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    // find from cache `lista_projektow__/rejestr/lista` plan_harm_id where id === rejestrId
    const planHarmId = queryClient.getQueryData(['lista_projektow__/rejestr/lista'])?.list?.find(item => item.id === parseInt(rejestrId))?.plan_harm_id
    const clear_ph = new CLEAR_PH()

    const {mutate: zlozHarmonogram} = useZlozHarm()


    const acceptButtons = () => {
        return (
            <ButtonWithIcon
                icon={<Icons.send/>}
                onClick={() => zlozHarmonogram({id: planHarmId})}
                variant={'success'}
                text={'Złóż harmonogram'}
                className={'ms-0 p-2'}
            />
        )
    }

    return (
        <>
            <HeaderTitle
                home
                nav
                size={'fs-2'}
                breadcrumbLinks={[
                    {
                        label: 'Wszystkie projekty',
                        to: `/${rola}/rejestr/lista`,
                    },
                    {label: 'Wypełnij plan harmonogramu'},
                ]}
                data={[['ID', rejestrId]]}
                destination={`/${rola}/rejestr/lista`}
                title={'Wypełnij plan harmonogramu'}
            />
            <Wizard
                debug
                mode={tryb}
                name={WZOR_NAME}
                dataUrl={`${rolaParam}plan-harm/${rejestrId}`}
                validationUrl={`${rolaParam}plan-harm/${rejestrId}/podsumowanie`}
                saveUrl={`${rolaParam}plan-harm`}
                mappingUrl={`${rolaParam}plan-harm/wzor/${WZOR_NAME}`}
                acceptButtons={acceptButtons}
                saveOnPageChange={true}
                stateForPage={false}
                saveAndQuitCallback={() => navigate(`/${rola}/rejestr/lista`)}
                cancelCallback={() => navigate(`/${rola}/rejestr/lista`)}
                filterByCategory={false}
                pages={[
                    {name: 'start', calc: (form) => clear_ph.dane(form), form: <Start/>},
                    {name: 'etap_inicjacji', calc: (form) => clear_ph.dane(form), form: <EtapInicjacji/>},
                    {name: 'etap_przygotowania', calc: (form) => clear_ph.dane(form),form: <EtapPrzygotowania/>},
                    {name: 'etap_realizacji', calc: (form) => clear_ph.dane(form), form: <EtapRealizacji/>},
                    {name: 'etap_zamykania', calc: (form) => clear_ph.dane(form), form: <EtapZamykania/>},
                    {
                        name: 'podsumowanie',
                        form: <Podsumowanie/>,
                        summary: true,
                    },
                ]}
            />
        </>
    )
}

export default ViewPlanHarmForm
